import {
    BILLING_PLAN_LIST_REQUEST, BILLING_PLAN_LIST_SUCCESS, BILLING_PLAN_LIST_FAIL,
    BILLING_PLAN_DETAILS_REQUEST, BILLING_PLAN_DETAILS_SUCCESS, BILLING_PLAN_DETAILS_FAIL, BILLING_PLAN_DETAILS_RESET,
    BILLING_PLAN_CREATE_REQUEST, BILLING_PLAN_CREATE_SUCCESS, BILLING_PLAN_CREATE_FAIL, BILLING_PLAN_CREATE_RESET,
    BILLING_PLAN_UPDATE_REQUEST, BILLING_PLAN_UPDATE_SUCCESS, BILLING_PLAN_UPDATE_FAIL, BILLING_PLAN_UPDATE_RESET,
    BILLING_PLAN_DELETE_REQUEST, BILLING_PLAN_DELETE_SUCCESS, BILLING_PLAN_DELETE_FAIL,
    BILLING_PLAN_DTO_REQUEST, BILLING_PLAN_DTO_SUCCESS, BILLING_PLAN_DTO_FAIL, BILLING_PLAN_DTO_RESET,
    SET_CURRENT_PAGE,
} from '../constants/billingPlanConstants';

export const billingPlanListReducer = (state = { billingPlans: [] }, action) => {
    switch (action.type) {
        case BILLING_PLAN_LIST_REQUEST:
            return { loading: true, billingPlans: [] };
        case BILLING_PLAN_LIST_SUCCESS:
            return {
                loading: false,
                billingPlans: action.payload.items,
                totalPages: action.payload.totalPages,
                currentPage: action.payload.currentPage,
                totalCount: action.payload.totalCount,
            };
        case SET_CURRENT_PAGE:
            return {
                ...state,
                currentPage: action.payload
            };
        case BILLING_PLAN_LIST_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const billingPlanDetailsReducer = (state = { billingPlan: {} }, action) => {
    switch (action.type) {
        case BILLING_PLAN_DETAILS_REQUEST:
            return { loading: true, ...state };
        case BILLING_PLAN_DETAILS_SUCCESS:
            return { loading: false, billingPlan: action.payload };
        case BILLING_PLAN_DETAILS_FAIL:
            return { loading: false, error: action.payload };
        case BILLING_PLAN_DETAILS_RESET:
            return { billingPlan: {} };
        default:
            return state;
    }
};

export const billingPlanDtoReducer = (state = { billingPlanDto: {} }, action) => {
    switch (action.type) {
        case BILLING_PLAN_DTO_REQUEST:
            return { loading: true, billingPlanDto: {} };
        case BILLING_PLAN_DTO_SUCCESS:
            return { loading: false, billingPlanDto: action.payload };
        case BILLING_PLAN_DTO_FAIL:
            return { loading: false, error: action.payload };
        case BILLING_PLAN_DTO_RESET:
            return { billingPlanDto: {} };
        default:
            return state;
    }
};

export const billingPlanDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case BILLING_PLAN_DELETE_REQUEST:
            return { loading: true };
        case BILLING_PLAN_DELETE_SUCCESS:
            return { loading: false, success: true };
        case BILLING_PLAN_DELETE_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const billingPlanCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case BILLING_PLAN_CREATE_REQUEST:
            return { loading: true };
        case BILLING_PLAN_CREATE_SUCCESS:
            return { loading: false, success: true, billingPlan: action.payload };
        case BILLING_PLAN_CREATE_FAIL:
            return { loading: false, error: action.payload };
        case BILLING_PLAN_CREATE_RESET:
            return {};
        default:
            return state;
    }
};

export const billingPlanUpdateReducer = (state = { billingPlan: {} }, action) => {
    switch (action.type) {
        case BILLING_PLAN_UPDATE_REQUEST:
            return { loading: true };
        case BILLING_PLAN_UPDATE_SUCCESS:
            return { loading: false, success: true, billingPlan: action.payload };
        case BILLING_PLAN_UPDATE_FAIL:
            return { loading: false, error: action.payload };
        case BILLING_PLAN_UPDATE_RESET:
            return { billingPlan: {} };
        default:
            return state;
    }
}; 